(function(angular) {
    'use strict';

    angular.module('nucleus.dashboard', [
        'pascalprecht.translate',
        'nucleus.widgets',
        'bluemoon.myAccount',
        'bmProfilePhoto',
        'nucleus.trial-widget',
        'bluemoon.components',
        'nucleus.bm-help-widget',
        'nucleus.dashboard.landingPageService',
        'nucleus.HideHeaderOnIframeDirective',
        'nucleus.HideHeaderOnSetupFirmIframeDirective',
        'nucleus.DynamicWidgetTemplateDirective'
    ]);
}(window.angular));
